import _ from 'lodash';

import * as React from 'react'
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';
import { Segment, Button } from 'semantic-grab-ui/src';
import { getEntity } from 'actions/common';
import { getListRuleTypes } from 'actions/newTridentExtra';
import { Link } from 'react-router';
import { Campaign} from 'types/ts/campaigns.ts';
import { RuleType } from 'types/ts/rule-types.ts';
import './TridentCampaignView.scss';
import TridentCampaignSummary from './TridentCampaignSummary';
import { JOURNEY_CAMPAIGN_TYPE } from "omega-rtc/views/trident-campaigns/common/util";

interface TridentCampaignViewProps {
  params: {
    entityID: string,
    countryID: number,
  },
  routerProps: {
    location: {
      query: string,
    }
  },
  getEntity: Function,
  getListRuleTypes: Function,
  campaign: Campaign,
  listRuleTypes: RuleType[],
}

export class TridentCampaignView extends React.Component<TridentCampaignViewProps> {
  componentDidMount() {
    this.props.getEntity('tridentCampaigns', this.props.params.entityID, {
      ..._.get(this.props.routerProps, 'location.query', {}),
      ...this.props.params,
    });
  }

  componentWillReceiveProps(nextProps: TridentCampaignViewProps) {
    if (nextProps.campaign !== this.props.campaign) {
      const owner = _.get(nextProps.campaign, 'owner', '');
      const targetUserType = _.get(nextProps.campaign, 'targetUserType', '');
      this.props.getListRuleTypes({ owner, targetUserType });
    }
  }

  render() {
    const { campaign, params } = this.props;
    const { countryID = 4, entityID = ''} = params;

    const campaignType = _.get(campaign, 'campaignType', '');
    const isJourneyCampaign = campaignType === JOURNEY_CAMPAIGN_TYPE;
    return (
      <DocumentTitle title={'View Trident Campaign'}>
        <div className={`${isJourneyCampaign ? 'disabled' : ''}`}>
          {isJourneyCampaign && <h1>Journey campaign view not supported. Please use Holos</h1>}
          <div className="campaign-view">
            <Button primary as={Link} to={`/campaigns/${countryID}/${entityID}/edit`}>
              Back to Edit Campaign
            </Button>
            <Segment>
              <TridentCampaignSummary campaign={campaign} listRuleTypes={this.props.listRuleTypes}/>
            </Segment>
          </div>
        </div>
        
      </DocumentTitle>
    );
  }
}

export function mapStateToProps(state) {
  return {
    campaign: state.tridentCampaigns.active,
    getEntityRequest: _.get(
      state.requests,
      `getEntity${_.upperFirst('tridentCampaigns')}Request`,
      {},
    ),
    listRuleTypes: _.get(state, 'newTridents.listRuleTypes', {}),
  };
}

export default connect(mapStateToProps, {
  getEntity,
  getListRuleTypes,
})(TridentCampaignView);
